import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header/Header';
import Contact from '../../Components/Contact/Contact';
import CareerContact from '../../Components/CareerContact/CareerContact';
import Footer from '../../Components/Footer/Footer';
import HeroCaseStudy from '../../Components/CaseStudies/HeroCaseStudy';
import ProminentWorksList from '../../Utils/ProminentWorksList';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO, trimForSEO } from '../../Utils/Constant';
import { MIXPANEL_EVENTS, track } from '../../Utils/mixpanel';

const CaseStudies = () => {
  let { companyName } = useParams();
  const navigate = useNavigate();
  const [caseStudyPageData, setCaseStudyPageData] = useState([]);

  useEffect(() => {
    if (companyName && ProminentWorksList && ProminentWorksList.length > 0) {
      const filteredCaseStudyPageData = ProminentWorksList.filter(
        (item) => item.path === companyName
      );
      if (filteredCaseStudyPageData && filteredCaseStudyPageData.length > 0) {
        setCaseStudyPageData(filteredCaseStudyPageData);
      } else {
        navigate('*');
        setCaseStudyPageData([]);
      }
    } else {
      setCaseStudyPageData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyName]);

  useEffect(() => {
    if (caseStudyPageData.length > 0 && caseStudyPageData[0]?.path) {
      track(MIXPANEL_EVENTS.CASE_STUDY_VIEWED, {
        case_study_slug: caseStudyPageData[0].path,
        case_study_title: caseStudyPageData[0].subTitle
      });
    }
  }, [caseStudyPageData]);

  return (
    <>
      <Helmet>
        <title>
          {caseStudyPageData[0]?.subTitle + ' | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP ||
            SEO.PROJECTS_PAGE_TITLE}
        </title>
        <meta
          name="description"
          content={trimForSEO(caseStudyPageData[0]?.content || '') || SEO.PROJECTS_PAGE_DESCRIPTION}
        />
        <link rel="canonical" href={window.location.href} />
        <meta
          name="keywords"
          content={caseStudyPageData[0]?.keywords || SEO.PROJECT_PAGE_KEYWORDS}
        />
        <meta
          property="og:title"
          content={
            caseStudyPageData[0]?.subTitle + ' | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP ||
            SEO.PROJECTS_PAGE_TITLE
          }
        />
        <meta
          property="og:description"
          content={trimForSEO(caseStudyPageData[0]?.content || '') || SEO.PROJECTS_PAGE_DESCRIPTION}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CONSTANT.PIXERFECT_WEB_LINK} />
        <meta property="og:site_name" content={CONSTANT.PIXERFECT_SOLUTIONS_LLP} />
        <meta property="og:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta property="twitter:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta
          name="twitter:title"
          content={
            caseStudyPageData[0]?.subTitle + ' | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP ||
            SEO.PROJECTS_PAGE_TITLE
          }
        />
        <meta
          name="twitter:description"
          content={trimForSEO(caseStudyPageData[0]?.content || '') || SEO.PROJECTS_PAGE_DESCRIPTION}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json" data-react-helmet="true">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name:
              caseStudyPageData[0]?.subTitle + ' | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP ||
              SEO.PROJECTS_PAGE_TITLE,
            description:
              trimForSEO(caseStudyPageData[0]?.content || '') || SEO.PROJECTS_PAGE_DESCRIPTION,
            keywords: caseStudyPageData[0]?.keywords || SEO.PROJECT_PAGE_KEYWORDS,
            url: window.location.href,
            image: 'https://www.pixerfect.com/Group_192_192.png'
          })}
        </script>
        <script type="application/ld+json" data-react-helmet="true">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name:
              caseStudyPageData[0]?.subTitle + ' | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP ||
              SEO.PROJECTS_PAGE_TITLE,
            description:
              trimForSEO(caseStudyPageData[0]?.content || '') || SEO.PROJECTS_PAGE_DESCRIPTION,
            keywords: caseStudyPageData[0]?.keywords || SEO.PROJECT_PAGE_KEYWORDS,
            url: window.location.href,
            image: 'https://www.pixerfect.com/Group_192_192.png'
          })}
        </script>
      </Helmet>

      <div>
        <Header />
        {caseStudyPageData && caseStudyPageData.length > 0 && (
          <HeroCaseStudy caseStudyData={caseStudyPageData[0]} />
        )}
        <Contact />
        <CareerContact />
        <Footer />
      </div>
    </>
  );
};

export default CaseStudies;
